// Sound Engine using Web Audio API - no external files needed
let audioCtx = null;
let soundEnabled = true;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

export function setSoundEnabled(enabled) {
  soundEnabled = enabled;
}

export function isSoundEnabled() {
  return soundEnabled;
}

function playTone(frequency, duration, type = 'sine', volume = 0.3) {
  if (!soundEnabled) return;
  try {
    const ctx = getAudioContext();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);
    gainNode.gain.setValueAtTime(volume, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + duration);
  } catch (e) {
    // Silently fail if audio not supported
  }
}

function playNotes(notes, interval = 0.15) {
  if (!soundEnabled) return;
  notes.forEach((note, i) => {
    setTimeout(() => {
      playTone(note.freq, note.dur || 0.2, note.type || 'sine', note.vol || 0.3);
    }, i * interval * 1000);
  });
}

// === GAME SOUNDS ===

export function playCorrectSound() {
  playNotes([
    { freq: 523, dur: 0.1, type: 'sine', vol: 0.25 },
    { freq: 659, dur: 0.1, type: 'sine', vol: 0.25 },
    { freq: 784, dur: 0.2, type: 'sine', vol: 0.3 },
  ], 0.08);
}

export function playWrongSound() {
  playNotes([
    { freq: 200, dur: 0.15, type: 'sawtooth', vol: 0.2 },
    { freq: 180, dur: 0.2, type: 'sawtooth', vol: 0.15 },
  ], 0.12);
}

export function playStreakSound() {
  playNotes([
    { freq: 523, dur: 0.08, type: 'sine', vol: 0.2 },
    { freq: 659, dur: 0.08, type: 'sine', vol: 0.25 },
    { freq: 784, dur: 0.08, type: 'sine', vol: 0.3 },
    { freq: 1047, dur: 0.3, type: 'sine', vol: 0.35 },
  ], 0.06);
}

export function playSuperStreakSound() {
  playNotes([
    { freq: 523, dur: 0.06, type: 'square', vol: 0.15 },
    { freq: 659, dur: 0.06, type: 'square', vol: 0.18 },
    { freq: 784, dur: 0.06, type: 'square', vol: 0.2 },
    { freq: 1047, dur: 0.06, type: 'square', vol: 0.25 },
    { freq: 1319, dur: 0.3, type: 'sine', vol: 0.3 },
  ], 0.05);
}

export function playCountdownSound() {
  playTone(440, 0.15, 'sine', 0.2);
}

export function playGoSound() {
  playNotes([
    { freq: 523, dur: 0.1, type: 'sine', vol: 0.3 },
    { freq: 784, dur: 0.1, type: 'sine', vol: 0.35 },
    { freq: 1047, dur: 0.3, type: 'sine', vol: 0.4 },
  ], 0.1);
}

export function playWinSound() {
  playNotes([
    { freq: 523, dur: 0.15, type: 'sine', vol: 0.25 },
    { freq: 659, dur: 0.15, type: 'sine', vol: 0.3 },
    { freq: 784, dur: 0.15, type: 'sine', vol: 0.3 },
    { freq: 1047, dur: 0.4, type: 'sine', vol: 0.35 },
  ], 0.15);
}

export function playTimerUrgentSound() {
  playTone(600, 0.08, 'sine', 0.15);
}

export function playButtonClickSound() {
  playTone(800, 0.05, 'sine', 0.1);
}

export function playKeypadSound() {
  playTone(500, 0.04, 'sine', 0.08);
}
